import { useAppPermissions } from '@/api/queries/useSdkTokenQuery';
import { useBoundStore } from '@/store';
import { useMemo } from 'react';

export function useProductUrls() {
  const selectedRegion = useBoundStore((state) => state.selectedRegion);
  const getCurrentSurveyUrl = useBoundStore((state) => state.getCurrentSurveyUrl);
  const getCurrentDigitalUrl = useBoundStore((state) => state.getCurrentDigitalUrl);
  const getCurrentWorkflowUrl = useBoundStore((state) => state.getCurrentWorkflowUrl);
  const getCurrentPulseUrl = useBoundStore((state) => state.getCurrentPulseUrl);
  const getCurrentReputationUrl = useBoundStore((state) => state.getCurrentReputationUrl);
  const getCurrentListingsUrl = useBoundStore((state) => state.getCurrentListingsUrl);
  const appPermissions = useAppPermissions();

  const productUrls = useMemo(() => {
    // Ensure the hook depends on selectedRegion changes
    void selectedRegion;

    return {
      survey: getCurrentSurveyUrl(),
      digital: getCurrentDigitalUrl(appPermissions),
      reputation: getCurrentReputationUrl(appPermissions),
      workflow: getCurrentWorkflowUrl(),
      dashboard: '/',
      pulse: getCurrentPulseUrl(appPermissions),
      listings: getCurrentListingsUrl(appPermissions),
    };
  }, [
    selectedRegion,
    appPermissions,
    getCurrentSurveyUrl,
    getCurrentDigitalUrl,
    getCurrentWorkflowUrl,
    getCurrentPulseUrl,
    getCurrentReputationUrl,
    getCurrentListingsUrl,
  ]);

  return productUrls;
}
